import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { CreateFeeGroupComponent } from "../../components/fee-group/create-fee-group/create-fee-group.component";
import { RegistrationService } from 'src/app/private/services/registration.service';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { DeleteFeeGroupComponent } from "../../components/fee-group/delete-fee-group/delete-fee-group.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-fees-configuration',
  imports: [SharedModule, ToolBarComponent, CreateFeeGroupComponent, DeleteFeeGroupComponent],
  templateUrl: './fees-configuration.component.html',
  styleUrl: './fees-configuration.component.scss'
})
export class FeesConfigurationComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddFeeGroup: boolean = false;
  editLeadFieldData: boolean = false;
  isEditAcademicYear: boolean = false;
  isDeleteAcademicYear: boolean = false;
  isViewBreakdown: boolean = false;
  feeGroupData: any;

  items: any[] = [];

  columns: any[] = [
    { field: 'group_name', header: 'Fee Group Name' },
    { field: 'description', header: 'Description', type: 'description' },
    { field: 'applicable_to', header: 'Applicable To' },
    { field: 'academic_year_name', header: 'Academic Year', type:'academic_year' },
    { field: 'course_name', header: 'Course', type:'course' },
    { field: 'total_fees', header: 'Total Fees' , type: 'currency' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  allCourses: any[] = [];
  fullCourseList: any[] = [];

  allAcademicYears: any[] = [];

  constructor(
    private api: FeeService,
    private registrationApi: RegistrationService,
    private academicYearApi: AcademicYearService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private router: Router
  ) { }


  ngOnInit() {
    this.fnGetAllCourses();
    this.getAllAcademicYears();
  }


  fnGetAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.registrationApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
        this.fullCourseList = data || [];
        this.allCourses = this.allCourses.map((course: any) => {
          return {
            label: course.name,
            value: course.course_id
          }
        });
      },
      error: (e) => {
        console.error(e);
      },
    });
  }


  getAllAcademicYears() {

    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId(),
      status: 'Active'
    };

    this.academicYearApi.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.allAcademicYears = data || [];
        this.allAcademicYears = this.allAcademicYears.map((year: any) => {
          return {
            label: year.year_name,
            value: year.id
          }
        });
      },
      error: (e) => {
        console.error(e);
      },
    });
   
  }



  AcademicYearActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Fee Group',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditAcademicYear = true;
          }
        },
        {
          label: 'View Breakdown',
          icon: 'pi pi-fw pi-eye',
          command: () => {
               this.router.navigate(['/main/settings/configuration-fees', this.feeGroupData.id]);
          }
        },
        {
          label: 'Delete Fee Group',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteAcademicYear = true;
          }
        }
      ]
    }
  ]


  setAcademicYearEditData(rowData: any) {
    this.feeGroupData = rowData;
  }


  loadData(event: any) {
    const page = event.first || 0;
    const size = event.rows || this.rows;

    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"academic_year\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.loading = true;

    this.api.getAllFeeGroupWithCount(param).subscribe({
      next: (data) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load academic years.' });
        this.initialLoad = false;
        this.loading = false;
      },
    });
  }

  reloadData() {
    this.loadData({ first: 0, rows: this.rows });
  }

  handleFeeGroup() {
    this.isAddFeeGroup = true;
  }

  handleCloseDialog() {
    this.isAddFeeGroup = false;
  }


}
